import type { IUiLinkMap } from '@experiences/interfaces';

export const AllocationWarning: IUiLinkMap = new Map([
    [ 'en', 'https://docs.uipath.com/automation-suite/docs/license-overallocation' ],
    [ 'ja', 'https://docs.uipath.com/automation-suite/lang-ja/docs/license-overallocation' ],
]);
